/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const DefaultSubmissionPageTabSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('DEFAULT_SUBMISSION_PAGE_TAB')],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(
        /* #__PURE__ */ parsers.exactly('auto-test', 'code', 'feedback-overview', 'peer-feedback', 'smart')),
    ],
]);
export class DefaultSubmissionPageTabSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return DefaultSubmissionPageTabSettingParser.decode(input).map(res => new DefaultSubmissionPageTabSetting(res));
    }
    static unsafeDecode(input) {
        return DefaultSubmissionPageTabSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return DefaultSubmissionPageTabSettingParser.encode(data);
    }
    static schema() {
        return DefaultSubmissionPageTabSettingParser.schema();
    }
}
